import Image from "next/image";
import { ArrowUp, Check, ChevronDown, Copy, Mic, Plus, SlidersHorizontal, ThumbsDown, ThumbsUp } from "lucide-react";
import { TwinMark } from "@product/components/app/twin/twin-mark";
import type { StoryAnswer } from "./answer-content";
import styles from "./external-chat.module.css";

type Provider = "chatgpt" | "claude" | "copilot";
const LABELS = { chatgpt: "ChatGPT", claude: "Claude", copilot: "Copilot" } as const;

export function AssistantMark({ provider }: { provider: Provider }) {
  if (provider === "copilot") return <span className={styles.copilotMark} aria-hidden="true" />;
  return <Image src={`/concepts/source-icons/${provider === "chatgpt" ? "chatgpt-mark" : "claude"}.svg`} width={20} height={20} alt="" />;
}

/** Branded illustrative clients; the answer and evidence come from one story. */
export function ExternalChat({ provider, answer }: { provider: Provider; answer: StoryAnswer }) {
  return <div className={styles.chat} data-provider={provider}>
    <div className={styles.transcript}>
      <div className={styles.prompt}>{answer.question}</div>
      <div className={styles.response}>
        <div className={styles.assistant}><AssistantMark provider={provider} /><strong>{LABELS[provider]}</strong></div>
        <div className={styles.tool}><TwinMark /><span>{provider === "copilot" ? "Your Twin agent" : "Used your Twin"}</span><Check size={12} aria-hidden="true" /></div>
        <p className={styles.answer}>{answer.parts.map((part, index) => <span key={index}>{part.text}{part.source !== undefined && <sup>{part.source + 1}</sup>}</span>)}</p>
        <ol className={styles.sources} aria-label="Answer sources">{answer.records.map((record, index) => <li key={record.name} title={`${record.title} · ${record.value}`}><span>{index + 1}</span><strong>{record.system.split(" / ")[0]}</strong></li>)}</ol>
        <div className={styles.responseActions} aria-hidden="true"><Copy /><ThumbsUp /><ThumbsDown /></div>
      </div>
    </div>
    <div className={styles.composer} aria-hidden="true">
      <span>{provider === "claude" ? "Reply to Claude…" : provider === "copilot" ? "Message Copilot" : "Ask anything"}</span>
      <div><Plus /><SlidersHorizontal /><span>{provider === "copilot" ? "Work" : provider === "claude" ? "Choose model" : "Tools"}<ChevronDown /></span><Mic /><i><ArrowUp /></i></div>
    </div>
  </div>;
}
